import { useSelector } from 'stores'
import {
  Company,
  FeatureFlag,
  FeatureFlagResponse,
  FeatureFlagValue,
} from '@types'
import { useService } from 'services'
import defaultValue from './default-values'

function containEqual(flagA: FeatureFlag, flagB: FeatureFlag): boolean {
  let result = true
  for (const k in flagA) {
    if (flagA[k] !== flagB[k]) {
      result = false
      break
    }
  }
  return result
}

export function useFeatureFlag() {
  const { featureFlag } = useService()
  const features = useSelector((state) => state.user.detail.data.features)

  function companyIsOnboarded(company: Company) {
    return company.id !== company.document_number
  }

  async function fetchFeatureFlag(
    company: Company
  ): Promise<FeatureFlagResponse> {
    if (company.id && companyIsOnboarded(company)) {
      return featureFlag.getAllByCurrentCompany(company.id)
    } else {
      return Promise.resolve(defaultValue)
    }
  }

  function on(featureFlag: FeatureFlagValue, rules?: FeatureFlag): boolean {
    const featureValue = features[featureFlag] as FeatureFlag | undefined

    if (!featureValue) {
      return false
    } else if (rules) {
      return containEqual(rules, featureValue)
    } else {
      return !!featureValue[featureFlag]
    }
  }

  function off(featureFlag: FeatureFlagValue, rules?: FeatureFlag): boolean {
    return !on(featureFlag, rules)
  }

  return { on, off, fetchFeatureFlag }
}
